var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg28Arrow2WayTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-10 -10 150 150",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinecap: "butt",
    d: "m0.005249344 89.74016l29.913385 -29.913387l0 14.956692l44.87008 0l0 -44.87008l-14.956692 0l29.913387 -29.913385l29.913383 29.913385l-14.956688 0l0 74.78347l-74.78347 0l0 14.956688z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg28Arrow2WayTurn);
export default __webpack_public_path__ + "static/media/28-arrow-2-way-turn.db3651e9a4798dff39a88e09ec4e8541.svg";
export { ForwardRef as ReactComponent };